import { IBranchesLog } from '~/view/screens/BranchLogScreen/screens/BranchesLogScreen/store/branchesLogStore';
import './style.scss';
import { localeStore } from '~/mobx/localesStore';

interface ChangesTableProps {
  log: IBranchesLog;
}

const ChangesTable: React.FC<ChangesTableProps> = ({ log }) => {
  const dataArray = Object.keys(log.changes).map((object) => ({
    object,
    object_name: log.object_name,
    old: log.changes[object]?.before,
    new: log.changes[object]?.after,
  }));

  const showHiddenValue = (value: any): any => {
    return String(value);
  };

  return (
    <div className="changes">
      <div className="changes-table">
        <div className="changes-table-header">
          <div className="changes-table-row">
            <div className="changes-table-cell size-object">{localeStore.t('name')}</div>
            <div className="changes-table-cell size-object">{localeStore.t('object')}</div>
            <div className="changes-table-cell size-old">{localeStore.t('old')}</div>
            <div className="changes-table-cell size-new">{localeStore.t('new')}</div>
          </div>
        </div>
        <div className="changes-table-body">
          {dataArray.map((item, index) => (
            <div key={index} className="changes-table-row changes-table-row-content">
              <div className="changes-table-cell table-cell-data size-object">{showHiddenValue(item.object_name)}</div>
              <div className="changes-table-cell table-cell-data size-object">{localeStore.t(item.object ?? '')}</div>
              <div className="changes-table-cell table-cell-data size-old">{showHiddenValue(item.old)}</div>
              <div className="changes-table-cell table-cell-data size-new">{showHiddenValue(item.new)}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ChangesTable;
